import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import { Scale } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  const contactInfo = {
    phone: '+380 95 045 81 21',
    email: 'advocategubareva@gmail.com'
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <Scale size={32} strokeWidth={1} />
              <span className="heading-3">{t.hero.name}</span>
            </div>
            <p className="body-regular footer-tagline">{t.hero.title}</p>
          </div>
          
          <div className="footer-contact">
            <a href={`tel:${contactInfo.phone}`} className="footer-link">{contactInfo.phone}</a>
            <a href={`mailto:${contactInfo.email}`} className="footer-link">{contactInfo.email}</a>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-legal-links">
            <Link to="/privacy-policy" className="footer-legal-link">{t.footer.privacy}</Link>
            <span className="footer-separator">•</span>
            <Link to="/disclaimer" className="footer-legal-link">{t.footer.disclaimer}</Link>
          </div>
          <p className="body-small">{t.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;